//MaterialProcurement.js
import React, { Component } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";
import TablePagination from "@mui/material/TablePagination";
import Autocomplete from "@mui/material/Autocomplete";
import Serverurl from "./Apiurl";
import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { InputLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
export default class MaterialProcurement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
      projectId: "",
      material: "",
      vendorId: "",
      projects: [],
      vendors: [],
      materials: [],
	    projectarray: [],
  projectarrauto: [],
  selectedProject: null,
  vendorarray: [],
  vendorarrauto: [],
  selectedVendor: null,
      reportData: [],
      loading: false,
	  page: 0,
rowsPerPage: 50,
totalRecords: 0,
      error: "",
	  mp_id: 0,
mp_amount: "",
openEdit: false,

    };
  }
  componentWillMount() {
	  
  if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Material Procurement";   
			 this.props.parentsCallback(
           strname
        );
  this.fetchReport();
}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
fetchReport = (e) => {
  if (e) e.preventDefault();
  this.setState({ loading: true });
axios.get(Serverurl +"ajaxmaterialprocurement.php" +"?action=getmaterialpurchasereport" +"&from_date=" +(this.state.fromDate? this.state.fromDate.format("YYYY-MM-DD"): "") +"&to_date=" +(this.state.toDate? this.state.toDate.format("YYYY-MM-DD"): "") +"&project_id=" +this.state.projectId +"&material=" +this.state.material +"&vendor_id=" +this.state.vendorId +"&index=" +this.state.page +"&maxrecord=" +this.state.rowsPerPage +"&orderby=mp_createddate DESC")
    .then((res) => {
      this.setState({
        reportData: res.data || [],
        totalRecords: res.data[0].count || 0,
        loading: false
      });
    })
    .catch(() => {
      this.setState({
        loading: false,
        error: "Error loading report"
      });
    });
};

handleClickSearch= (e) => {
	
	  this.fetchReport();
}
  downloadBill = (file) => {
      window.open(Serverurl + "uploads/" + file, "_blank");
  };
  handlePageChange = (event, newPage) => {
  this.setState({ page: newPage }, () => this.fetchReport());
};
handleRowsChange = (event) => {
  this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () => this.fetchReport()
  );
};
/*project autoextender*/
onloadProjectBind = (event) => {
axios.get(
  Serverurl +
    "ajaxprojects.php" +
    "?action=getallprojectautoextender" +
    "&projectname=" +
    encodeURIComponent(event.target.value)
)
    .then((resp) => {
      let strCust = [];
      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };
        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );
        if (!found) {
          strCust.push(item);
        }
      });
      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};
/*VENDOR AUTOEXTENER*/
onloadVendorBind = (event) => {
axios.get(
  Serverurl +
    "ajaxvendor.php" +
    "?action=vendorautoextender" +
    "&vendorname=" +
    encodeURIComponent(event.target.value)
)
    .then((resp) => {
      let strCust = [];
      (resp.data || []).forEach((row) => {
        const item = {
          title: row.vm_vendorname,
          vm_id: row.vm_id,
          rowindex: row.rowindex
        };
        const found = strCust.some(
          (el) => el.vm_id === row.vm_id
        );
        if (!found) {
          strCust.push(item);
        }
      });
      this.setState({
        vendorarray: resp.data || [],
        vendorarrauto: strCust
      });
    });
};
onVendorChange = (event, value) => {
  this.setState({
    selectedVendor: value,
    vendorId: value ? value.vm_id : ""
  });
};
//popupwindow
editRecord = (row) => {
  this.setState({
    mp_id: row.mp_id,
    mp_amount: row.Amount, // backend field
    openEdit: true
  });
};
handleClose = () => {
  this.setState({
    openEdit: false,
    mp_id: 0,
    mp_amount: ""
  });
};
handleNumericChange = (field, e) => {
  const value = e.target.value;
  if (/^\d*\.?\d*$/.test(value)) {
    this.setState({ [field]: value });
  }
};
updateAmount = () => {
  let formData = new FormData();
  formData.append("action", "materialpurchasereportupdateamount");
  formData.append("mp_id", this.state.mp_id);
  formData.append("mp_amount", this.state.mp_amount);
  formData.append("userid",localStorage.getItem("VRuserid"));
  axios
    .post(
      Serverurl + "ajaxmaterialprocurement.php",
      formData
    )
    .then(() => {
      this.setState({ openEdit: false });
      this.fetchReport();
    });
};
getUnitName = (unitId) => {
  switch (Number(unitId)) {
    case 1:
      return "KG";
    case 2:
      return "TON";
    case 3:
      return "BAG";
    case 4:
      return "CFT";
    case 5:
      return "M3";
	   case 6:
      return "SQFT";
	   case 7:
      return "MTR";
	   case 8:
      return "Running Feet";
	   case 9:
      return "NOS";
	   case 10:
      return "LTR";
	  case 11:
      return "Bundle";
	  case 12:
      return "Sheet";
    default:
      return "";
  }
};
render() {
  const { reportData } = this.state;

  const totalAmount = reportData.reduce((sum, row) => {
    return sum + (parseFloat(row.Amount) || 0);
  }, 0);

  return (

     
         <React.Fragment>
              
              
                       

                        <div className="searchmaster">
                            <ul>
                            
                                <li>
            <p  >From Date</p>
			
			 <p> <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker className="inputcntlparent"
              value={this.state.fromDate}
              onChange={(newValue) =>
                this.setState({ fromDate: newValue })
              }
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small"
                }
              }}
            /></LocalizationProvider></p>
      </li>

        <li>
            <p  >To Date</p>
			 <p> <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker className="inputcntlparent"
              value={this.state.toDate}
              onChange={(newValue) =>
                this.setState({ toDate: newValue })
              }
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small"
                }
              }}
            /></LocalizationProvider>
       </p>
      </li>


          <li>
            <p  >Project</p>
  <p  >
            <Autocomplete className="inputcntlparent"
              options={this.state.projectarrauto}
              value={this.state.selectedProject}
              onChange={this.onProjectChange}
              getOptionLabel={(option) => option.title || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search Project"
                  onChange={this.onloadProjectBind}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>{option.title}</li>
              )}
              fullWidth
            />
          </p></li>

          <li  >
            <p  >Vendor</p>
  <p  >
            <Autocomplete className="inputcntlparent"
              options={this.state.vendorarrauto}
              value={this.state.selectedVendor}
              onChange={this.onVendorChange}
              getOptionLabel={(option) => option.title || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search Vendor"
                  onChange={this.onloadVendorBind}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>{option.title}</li>
              )}
              fullWidth
            />
          </p></li>

         <li>
            <p >
            <Button
              type="submit"
              variant="contained"
           
               className="exportbtn" onClick={this.handleClickSearch} endIcon={<SearchIcon />}
            >
              SEARCH
            </Button></p></li></ul>
          </div>
       

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow >
              <TableCell  >
                Date
              </TableCell>
              <TableCell  >
                Project
              </TableCell>
              <TableCell  >
                Material
              </TableCell>
              <TableCell  >
                Vendor Name
              </TableCell>
              <TableCell  >
                Quantity
              </TableCell>
              <TableCell  >
                Amount
              </TableCell>
              <TableCell  >
                Remarks
              </TableCell>
              <TableCell  >
                Bill
              </TableCell>
              <TableCell  >
                Photo
              </TableCell>
              <TableCell  >
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {reportData.map((r, i) => (
              <TableRow key={i} hover>
                <TableCell>
                  {r.PurchaseDate
                    ? dayjs(r.PurchaseDate).format("DD/MM/YYYY")
                    : ""}
                </TableCell>

                <TableCell>{r.ProjectName}</TableCell>

                <TableCell>{r.MaterialName}</TableCell>

                <TableCell>{r.VendorName}</TableCell>

                <TableCell>
                  {r.Quantity} {r.unit_name}
                </TableCell>

                <TableCell>
                 Rs. {parseFloat(r.Amount || 0).toFixed(2)}
                </TableCell>

                <TableCell>{r.Remarks}</TableCell>

                <TableCell>
				{r.BillFile!=="" && (
                  <Button
                    size="small"
                    onClick={() =>
                      this.downloadBill(r.BillFile)
                    }
                  >
                    Download
				</Button>)}
                </TableCell>

                <TableCell>
                  {r.MaterialImage ? (
                     <a
            href={Serverurl+'uploads/'+r.MaterialImage}
            alt="material" target="_blank"

          >View</a>
                  ) : (
                    ""
                  )}
                </TableCell>

                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => this.editRecord(r)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}

            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell colSpan={5} align="right">
                <strong>Total</strong>
              </TableCell>

              <TableCell>
                <strong>
                  Rs. {totalAmount.toFixed(2)}
                </strong>
              </TableCell>

              <TableCell />
            </TableRow>
          </TableBody>
        </Table>

        <TablePagination
		  rowsPerPageOptions={[50, 100, 150, 200, 250]}  
          component="div"
          count={this.state.totalRecords}
          page={this.state.page}
          onPageChange={this.handlePageChange}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.handleRowsChange}
		     
        />

        <Dialog
          open={this.state.openEdit}
          onClose={this.handleClose}
        >
          <DialogTitle>
            Material Procurement
          </DialogTitle>

          <DialogContent>
            <div style={{ marginTop: "10px" }}>
              <p
                style={{
                  marginBottom: "5px",
                  color: "#666"
                }}
              >
                Amount
              </p>

              <TextField
                fullWidth
                size="small"
                value={this.state.mp_amount}
                onChange={(e) =>
                  this.handleNumericChange(
                    "mp_amount",
                    e
                  )
                }
				
			  slotProps={{
                         htmlInput: {
                         maxLength:8,
                         tabIndex:1
                   }
                }}

              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleClose}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={this.updateAmount}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </TableContainer>
      </React.Fragment>
  );
}
}
